/**
 * Triggers a streamed download via a hidden anchor click. Deliberately omits:
 *  - `target="_blank"`: Safari blocks it as a popup when the click is async
 *    from the original user gesture (e.g. an export job's URL arriving after a delay).
 *  - `download="..."`: Safari ignores it cross-origin, and our pre-signed S3
 *    URLs are cross-origin. The server sets the filename via
 *    `response-content-disposition=attachment; filename="..."` instead.
 *  - `window.location.href = url`: Safari also treats this as a popup when async.
 * The browser sees Content-Disposition: attachment on the response and streams
 * the file to disk without ever navigating the page — works for large files
 * with no JS memory cost.
 */
export const triggerDownload = (url: string): void => {
  const a = document.createElement('a');
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/** Saves a Blob made in the browser (same-origin, so `download` names the file) via a temporary object URL. */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
